import { Theme, Typography, useTheme } from "@mui/material"
import { Top10BondHoldingsProps } from "../types"
import { Box } from "@mui/system"
import CustomTable from "../../common/customTable"
import { Top10BondHoldingsHeaderData } from "./tableHeaders"
import { Top10BondsHoldingBody } from "./tableBodies"
import { Top10BondHoldingsLoader } from "../bondsOverViewLoading"
import { NO_DATA_ERROR_MESSAGE } from "../../../../utils/constant"

export const Top10BondHoldings = (props: Top10BondHoldingsProps): JSX.Element => {
    const { title, tableData, isLoading, clientCode, completeData } = props
    const { palette } = useTheme()
    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px',
            width: '100%',
        }}>
            {isLoading && <Top10BondHoldingsLoader />}
            {(!isLoading && !completeData?.isSuccess) && <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary
                    })}
                >
                    {NO_DATA_ERROR_MESSAGE}
                </Typography>
            </Box>}
            {(!isLoading && completeData?.isSuccess) &&
                <>
                    <Typography variant="h2" color={palette.text.primary}>
                        {title}
                    </Typography>
                    <Box mt={'20px'}>
                        <CustomTable
                            loadingRowsNum={4}
                            isLoading={false}
                            tableBody={
                                <Top10BondsHoldingBody
                                    clientCode={clientCode}
                                    tableBodyData={tableData || []}
                                    handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                                />
                            }
                            tableData={tableData || []}
                            tableBodyLoaderRowCustomStyles={{
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            }}
                            tableHeaderData={Top10BondHoldingsHeaderData}
                            tableHeadRowCustomStyles={{
                                '& th:first-of-type': {
                                    paddingLeft: "0px",
                                }
                            }}
                            handleSort={() => { console.log("SORT") }}
                            tableBodyCustomStyles={{
                                '& tr:last-child td': {
                                    border: 0
                                }
                            }}
                            // order={sortingObj.order}
                            // orderBy={sortingObj.orderBy}
                            tableDataCount={tableData?.length || 0}
                            isPaginationVisible={false}
                        />
                    </Box>
                </>
            }

        </Box>
    )
}